import * as React from 'react';
import SidebarContainer from 'src/modules/Routing/Sidebar/SidebarContainer';
import { Scrollbars } from 'react-custom-scrollbars';
import { RealtimeServicesStatus } from './component/Status';
import LastProcessed from './component/LastProcessed';
import { match } from 'react-router';
import routes from 'src/modules/Routing/routes';
import './servicesStatus.css';
import { RoutesModules } from 'src/modules/Routing/types';

export interface IServicesStatusProps {
  match: match
}

export interface IServicesStatusState {
  mode: 'rek' | 'etl'
}

export class ServicesStatus extends React.Component<IServicesStatusProps, IServicesStatusState> {
  constructor(props: IServicesStatusProps) {
    super(props);

    this.state = {
      mode: 'rek'
    }
  }
  public static getDerivedStateFromProps(nextProps: IServicesStatusProps) {
    return { mode: nextProps.match.path === routes.RECOGNITIONLOGS ? "rek" : "etl" }
  }
  public render() {
    const isRek = this.state.mode === "rek";
    return (
      <Scrollbars
        style={{ width: '100%' }}
        autoHeigh={true}
        autoHide={true}
        autoHideTimeout={1000}
        autoHideDuration={200}
      >
        <div className="stats servicesStatus">
          <h2>{isRek ? "Recognition" : "ETL"} server status</h2>
          <RealtimeServicesStatus mode={this.state.mode} />
          <LastProcessed mode={this.state.mode} />
        </div>
      </Scrollbars>
    );
  }
}

export default SidebarContainer(RoutesModules.ADMIN)(ServicesStatus);
